import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { SubscriptionState } from "../types";

const getters: GetterTree<SubscriptionState, RootState> = {
  allSubscriptionPlans: (state) => state.plans,
  getAllCreditCards: (state) => state.cards,
  getVerificationUsedQuota: (state) => state.verificationQuotaUsed,
  getVerificationQuota: (state) => state.verificationQuota,
  getAmlUsedQuota: (state) => state.amlQuotaUsed,
  getAmlQuota: (state) => state.amlQuota,
  getCurrentSubscriptionPlan: (state) => state.currentSubscriptionPlan,
  getIsSandboxAccount: (state) => state.isSandbox,
  getAllInvoices: (state) => state.invoices,
  getQuotaExpirationDate: (state) => state.quotaExpirationDate,
  getQuotaStartDate: (state) => state.quotaStartDate,
  getMode: (state) => state.mode,
  isSandboxActive: (state) => state.mode === 0 || state.mode === 2,
  isQuotaExpired: (state) =>
    Date.now() >= Date.parse(state.quotaExpirationDate),
  getPricePerVerification: (state) => state.pricePerVerification,
  isPepEnabled: (state) => state.hasPepEnabled,
  isSanctionEnabled: (state) => state.hasSanctionEnabled,
  isKybEnabled: (state) => state.hasKybEnabled,
};

export default getters;
